<template>
    <div>
        <b-modal
            id="modify-Variant-popup"
            ref="modal"
            :title="titlePopup"
            size="sm"
            hide-footer
            modal-class="hide-footer"
            no-close-on-backdrop
            :hide-header-close="loading"
            no-close-on-esc
            @hidden="onHidden"
        >
            <div class="row custom-model-form">
                <div class="col-md-12">
                    <b-form-group
                        id="input-group-3"
                        label="Original Word"
                        label-for="original-word-id"
                    >
                        <b-form-input
                            id="original-word-id"
                            v-model="formData.keyword"
                            type="text"
                            autocomplete="no"
                            placeholder="Enter Original Word"
                            name="original_word"
                            :class="{
                                'is-invalid': errors.has('Original Word'),
                            }"
                        ></b-form-input>
                    </b-form-group>
                </div>

                <!-- Button to add a new child variant input -->
                <div class="col-md-12 my-2">
                    <base-button
                        v-if="formData.variants.length < 3"
                        btn-label="Add Variant"
                        btn-variant="secondary"
                        @click="addVariantInput"
                    ></base-button>
                </div>

                <!-- Show input fields for child variants -->
                <div
                    v-for="(variant, index) in formData.variants"
                    :key="index"
                    class="col-md-12 mt-2"
                >
                    <div class="row align-items-center mt-2">
                        <b-form-group
                            :id="'input-group-variant-' + index"
                            class="col-md-8"
                            :label="'Child Variant ' + (index + 1)"
                            :label-for="'child-variant-id-' + index"
                        >
                            <b-form-input
                                :id="'child-variant-id-' + index"
                                v-model="formData.variants[index].keyword"
                                type="text"
                                autocomplete="no"
                                :placeholder="
                                    'Enter Child Variant ' + (index + 1)
                                "
                                :name="'child_variant_' + index"
                                :class="{
                                    'is-invalid': errors.has('Child Variant'),
                                }"
                                @input="capitalizeFirstWord(index)"
                            ></b-form-input>
                        </b-form-group>
                        <div class="col-md-4">
                            <base-action
                                icon="icon-trash"
                                :icon-color="parentColor"
                                :icon-font-size="parentFontSize"
                                @click="
                                    deleteVariant(formData.variants[index]._id)
                                "
                            ></base-action>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 action-buttons">
                <base-button
                    :btn-label="buttonLabel"
                    btn-type="submit"
                    btn-variant="primary"
                    :class="loading ? 'disabled' : ''"
                    @click="onSubmit"
                ></base-button>
                <base-button
                    btn-label="Cancel"
                    btn-type="reset"
                    :disabled="loading"
                    btn-variant="link"
                    @click="onHidden"
                ></base-button>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import _ from 'lodash'
const apiUrl_data = process.env.VUE_APP_API_URL
export default {
    /*
  |--------------------------------------------------------------------------
  | Component > props
  |--------------------------------------------------------------------------
  */
    props: {
        title: {
            type: String,
            default: null,
        },
        buttonText: {
            type: String,
            default: 'Create',
        },
    }, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            formData: this.initializeFormData(),
            parentVariants: [],
            parentColor: '#7f8fa4',
            parentFontSize: '18px',
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'loading',
            'selectedItem',
            'hidePopup',
            'dataSegmentId',
        ]),
        titlePopup() {
            return this.selectedItem
                ? 'Modify Variant Word' /*+ ' ' + this.formData.title*/
                : 'Add Variant Word'
        }, // End of titlePopup() method
        buttonLabel() {
            return this.selectedItem ? 'Update' : 'Create'
        }, // End of buttonLabel() method
    },

    watch: {
        /**
         * Handle when the selected has been updated
         *
         * @return {void}
         */

        selectedItem(value) {
            console.log('value is', value)
            if (value !== null && value !== undefined) {
                console.log('value', Object.assign(this.formData, value))
                Object.assign(this.formData, value)
            } else {
                this.onHidden()
            }
        },
        /**
         * Handle when the popup hide
         *
         * @return {void}
         */
        hidePopup(value) {
            if (value) {
                this.onHidden()
            }
        },
    }, // End of Component > methods
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */

    mounted() {
        this.getVariantWords()
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        async getVariantWords() {
            let response = await axios.get(
                apiUrl_data + 'configurations/variant-words',
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem(
                            'vueauth_token'
                        )}`,
                    },
                    params: {
                        dataSegmentId: localStorage.getItem(
                            'activeDataSegmentId'
                        ),
                    },
                }
            )
            if (response) {
                console.log('WORDS', response.data.data)
                let words = response.data.data
                if (words.length != 0) {
                    for (let index = 0; index < words.length; index++) {
                        this.parentVariants.push(words[index].keyword)
                    }
                }
            }
            console.log('parent variants', this.parentVariants)
        },

        capitalizeFirstWord(index) {
            // Capitalize the first word using lodash upperFirst
            this.formData.variants[index].keyword = _.upperFirst(
                this.formData.variants[index].keyword
            )
        },

        initializeFormData() {
            return {
                _id: null,
                dataSegmentId: '',
                keyword: '',
                type: 'variantWord',
                variants: [],
            }
        }, // End of initializeFormData() method
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            this.$store.commit('onSubmit', null)
            Object.assign(this.formData, this.initializeFormData())
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method

        async onSubmit() {
            this.formData.dataSegmentId = localStorage.getItem(
                'activeDataSegmentId'
            )
            console.log()
            // Add parentVariantId to the formData
            const result = await this.$validator.validateAll()
            if (result) {
                try {
                    // console.log('value is',this.threshold)
                    // this.$emit('click',this.threshold)
                    // this.$refs.modal.hide()
                    console.log('FORMDATA', this.formData)
                    await this.$store.dispatch('onSubmit', this.formData)
                } catch (error) {
                    console.log(error, 'There is an error on submit')
                }
            }
        },

        deleteVariant(id) {
            // console.log("Button clicked", id)
            this.formData.variants = this.formData.variants.filter(
                (variant) => variant._id != id
            )
        },

        addVariantInput() {
            // Add a new child variant input
            this.formData.variants.push({ keyword: '' })
        }, // End of onSubmit() method
    }, // End of Component > watch
}
</script>
